import React from "react";
import { Phone } from "lucide-react";

const PHONE = "+919131341638";

export default function FloatingCallButton() {
  return (
    <a
      href={`tel:${PHONE}`}
      className="fixed bottom-36 right-5 md:bottom-24 md:right-6 z-30 w-12 h-12 md:w-13 md:h-13 rounded-full bg-emerald-500 hover:bg-emerald-600 hover:scale-105 active:scale-95 flex items-center justify-center shadow-[0_8px_30px_-4px_rgba(34,197,94,0.55)] transition-all"
      aria-label="Call CodeWithKamlesh"
      data-testid="floating-call-btn"
    >
      <span className="absolute inset-0 rounded-full bg-emerald-400/40 animate-ping" />
      <Phone className="relative w-5 h-5 text-white" />
    </a>
  );
}
